module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bulma-checkbox",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "button is-primary is-inverted",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])]), _c('label', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e966ac5"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/bulmaCheckbox.vue
// module id = 419
// module chunks = 0